var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"answerText",style:([
    {
      color: _vm.siteSettings.textColor,
      fontSize: _vm.siteSettings.textSize
    },
    _vm.active ? _vm.hoverStyle : ''
  ]),on:{"mouseover":_vm.hover,"mouseout":_vm.endHover}},[_vm._v(" "+_vm._s(_vm.answerText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }